<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="工号：" required>
                  <el-input v-model="employeeData.employee_no" placeholder="工号" clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名：" required>
                  <el-input v-model="employeeData.employee_name" placeholder="姓名" clearable/>
                </el-form-item>
                <el-form-item label="岗位：" required>
                  <el-input v-model="employeeData.job_id" placeholder="岗位" clearable/>
                  <!--                  <el-select v-model="employeeData.job_id" placeholder="岗位"  filterable clearable>
                                      <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                                    </el-select>-->
                </el-form-item>
                <el-form-item label="职务：">
                  <el-input v-model="employeeData.position_id" placeholder="职务" clearable/>
                  <!--                  <el-select v-model="employeeData.position_id" placeholder="职务"  filterable clearable>
                                      <el-option v-for="item in positionOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                                    </el-select>-->
                </el-form-item>
                <el-form-item label="员工类型：" required>
                  <el-select v-model="employeeData.employee_type" placeholder="员工类型" clearable>
                    <el-option v-for="item in employeeTypeList" :key="item.id" :label="item.employee_type_name"
                               :value="item.id"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号码：" required>
                  <el-input v-model="employeeData.phone" placeholder="手机号码" clearable/>
                </el-form-item>
                <el-form-item label="企业邮箱：">
                  <el-input v-model="employeeData.email" placeholder="企业邮箱" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item>
                <kf-image-upload class="employee-photo" v-model="employeeData.photo" :init-file="employeeData.photo_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人力资源类型：">
              <el-select v-model="employeeData.hr_type" placeholder="间接/直接"  filterable clearable>
                <el-option v-for="item in hrList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="厂外工龄：">
              <el-input-number style="width: 100%" v-model="employeeData.work_year_out"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入集团日期：" required>
              <el-date-picker v-model="employeeData.entry_corporation_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职日期：" required>
              <el-date-picker v-model="employeeData.entry_factory_date" type="date" placeholder="选择日期"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="隶属厂区：" required>
              <el-select v-model="employeeData.factory_id" placeholder="隶属厂区"  filterable disabled>
                <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="隶属公司：" required>
              <el-select v-model="employeeData.company_id" placeholder="隶属公司"  filterable clearable>
                <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.all_department_ids" :options="departmentList"
                           :props="mulOptionProps" :show-all-levels="true" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="是部门负责人：">
              <div class="switch-group">
                <div
                    v-for="(deptPath, index) in employeeData.all_department_ids"
                    :key="index"
                    class="switch-item"
                >
                  <span class="dept-label">{{ `部门${index + 1}` }}：</span>
                  <el-switch v-model="employeeData.leader_dept[index]" />
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主部门：" required>
              <el-cascader v-model="employeeData.main_department_id" :options="departmentList"
                           :props="optionProps" :show-all-levels="true" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="display: flex;justify-content: space-between">
      <label style="margin-left: 5px;font-weight: bold">身份信息:</label>
    </div>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="姓名：">
                  <el-input v-model="idCardInfo.employee_name" placeholder="姓名" clearable/>
                </el-form-item>
                <el-form-item label="性别：">
                  <el-select v-model="idCardInfo.gender" placeholder="性别" clearable>
                    <el-option label="男" value="男"/>
                    <el-option label="女" value="女"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="民族：">
                  <el-input v-model="idCardInfo.ethnicity" placeholder="民族" clearable/>
                </el-form-item>
                <el-form-item label="出生日期：">
                  <el-date-picker v-model="idCardInfo.date_of_birth" type="date"
                                  value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="月份：">
                  <el-input v-model="idCardInfo.birth_month" placeholder="月份" clearable/>
                </el-form-item>
                <el-form-item label="公民身份证号码：">
                  <el-input v-model="idCardInfo.id_card_no" placeholder="公民身份证号码" clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" :offset="5">
            <div>
              <el-image :src="idCardInfo.avatar_show" style="width: 130px;height: 160px;margin-top: 60px">
                <template #error>
                  <div class="image-slot">
                    <el-icon><icon-picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="住址：">
          <el-input v-model="idCardInfo.address" placeholder="住址" clearable/>
        </el-form-item>
        <el-form-item label="签发机关：">
          <el-input v-model="idCardInfo.issue_authority" placeholder="签发机关" clearable/>
        </el-form-item>
        <el-form-item label="有效期限：">
          <el-col :span="11">
            <el-date-picker v-model="idCardInfo.expire_date_start" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
          <el-col :span="0.5" class="text-center">
            <span class="text-gray-500">-</span>
          </el-col>
          <el-col :span="12">
            <el-date-picker v-model="idCardInfo.expire_date_end" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="婚姻状况：">
              <el-input v-model="idCardInfo.marital_status" placeholder="婚姻状况" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯：">
              <el-input v-model="idCardInfo.origin_domicile" placeholder="籍贯" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="政治面貌：">
              <el-input v-model="idCardInfo.political_affiliation" placeholder="政治面貌" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>身份证正面照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>身份证反面照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo" :init-file="employeeData.man_photo_show_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo" :init-file="employeeData.nation_photo_show_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">非大陆身份信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型：">
              <el-select v-model="idCardInfo.card_type_othoer" placeholder="证件类型" clearable>
                <el-option v-for="item in cardTypeList" :key="item.id" :label="item.document_name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码：">
              <el-input v-model="idCardInfo.id_card_no_other" placeholder="证件号码"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>正面照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>反面照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.man_photo" :init-file="employeeData.man_photo_show_other_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="idCardInfo.nation_photo" :init-file="employeeData.nation_photo_show_other_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">合同信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同公司：">
              <el-input v-model="contractData.contract_company" placeholder="合同公司"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同类型：">
              <el-input v-model="contractData.contract_type" placeholder="合同类型"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="首次合同起始日：">
              <el-date-picker v-model="contractData.first_contract_start_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首次合同到期日：">
              <el-date-picker v-model="contractData.first_contract_end_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="现合同起始日：">
              <el-date-picker v-model="contractData.now_contract_start_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现合同到期日：">
              <el-date-picker v-model="contractData.now_contract_end_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同期限：">
              <el-input v-model="contractData.contract_period_type" placeholder="合同期限"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余天数：">
              <el-input v-model="contractData.contract_remaining_days" placeholder="剩余天数"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="到期提醒：">
              <el-input v-model="contractData.contract_expire_tip" placeholder="到期提醒"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="续签次数：">
              <el-input v-model="contractData.contract_renew_count" placeholder="续签次数"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="合同备注：">
              <el-input v-model="contractData.remark" placeholder="合同备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">试用期选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="试用期选项：">
              <el-switch v-model="employeeData.is_probation"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试用期：">
              <el-input v-model="employeeData.probation_period_type" placeholder="试用期"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="试用期结束日期：">
              <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.probation_end_date"
                              placeholder="选择日期" style="width: 100%" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">考勤选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="参与考勤：">
              <el-switch v-model="employeeData.is_join_attendance"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--            <el-form-item label="考勤组：">
                          <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.group_id"
                                          placeholder="选择日期" style="width: 100%" clearable/>
                        </el-form-item>-->
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">薪资选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="薪资类型：">
              <el-select v-model="salaryTypeItem" value-key="id" @change="salaryChange" placeholder="薪资类型"
                         clearable>
                <el-option v-for="item in salaryTypeList" :key="item.id" :label="item.salary_type" :value="item"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="薪资(底薪)：">
              <el-input :min="0" v-model="formattedSalary" placeholder="薪资(底薪)" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="标准津贴：">
              <el-input :min="0" v-model="employeeData.salary_allowance" :precision="2" step="1000" placeholder="标准津贴"
                               clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准补贴：">
              <el-input :min="0" v-model="employeeData.salary_subsidy" :precision="2" step="1000" placeholder="标准补贴"
                               clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="综合工资：">
              <el-input :min="0" v-model="employeeData.salary_contract"  style="width: 100%" placeholder="综合工资"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="防尘服补贴：">
              <el-switch v-model="employeeData.is_cloth_subsidy"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="补贴选项：">
              <el-switch v-model="employeeData.is_customization_subsidy" active-text="自定义补贴"/>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="">
              <el-checkbox v-model="employeeData.salary_car" :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">车补</el-checkbox>
              <el-checkbox v-model="employeeData.salary_house" :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">房补</el-checkbox>
              <el-checkbox v-model="employeeData.salary_on_job" :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">在职奖</el-checkbox>
              <el-checkbox v-model="employeeData.salary_full_attendance" :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">全勤奖</el-checkbox>
              <el-checkbox v-model="employeeData.salary_work_year" :disabled="!employeeData.is_customization_subsidy" style="margin-right: 8px">工龄奖</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">工资卡信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工资卡卡号：">
              <el-input v-model="employeeData.bank_card_no" placeholder="工资卡卡号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>工资卡照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="银行：">
                  <el-select v-model="employeeData.bank_id" placeholder="银行" clearable>
                    <el-option v-for="item in bankList" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户行：">
                  <el-input v-model="employeeData.account_bank" placeholder="开户行" :rows="4" type="textarea"
                            clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="employeeData.bank_card_photo" :init-file="employeeData.bank_card_photo_obj"  :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">社保:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保配置：">
                  <el-select v-model="socialSecurityTmplData" value-key="id" placeholder="社保配置" @change="getSbBase" clearable>
                    <el-option v-for="item in socialSecurityTmplList" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保缴纳地：">
                  <el-input v-model="employeeData.sb_base_area" placeholder="社保缴纳地" disabled clearable />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="社保账号：">
                  <el-input v-model="employeeData.sb_card_no" placeholder="社保账号"  clearable />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base" @change="setSbBase" name="self" size="small">自定义</el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.sb_base" placeholder="缴费基数" :disabled="is_custom" clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="个人部分承担方：">
                  <el-select v-model="employeeData.sb_pay_type" placeholder="个人部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="">
                  <span>社保卡照片</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.sb_card_photo" :init-file="employeeData.sb_card_photo_obj"  :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">公积金:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金配置：">
                  <el-input v-model="employeeData.gjj_template_name" disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金缴纳地：">
                  <el-input v-model="employeeData.gjj_base_area" placeholder="公积金缴纳地" disabled clearable />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公积金账号：">
                  <el-input v-model="employeeData.housing_fund_no" placeholder="公积金账号"  clearable />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="缴费基数：">
                  <el-col :span="6">
                    <el-checkbox v-model="employeeData.is_custom_base_gjj" @change="setHousingBase" name="self" size="small">自定义</el-checkbox>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="employeeData.gjj_base" placeholder="缴费基数" :disabled="is_custom_gjj" clearable/>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="额外部分承担方：">
                  <el-select v-model="employeeData.gjj_pay_type" placeholder="额外部分承担方" clearable>
                    <el-option v-for="item in costBoolList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="">
                  <span>公积金卡照片</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <kf-image-upload class="avatar-uploader" v-model="employeeData.housing_fund_photo" :init-file="employeeData.housing_fund_photo_obj"  :limit="1"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">学历信息:</label>
    <el-card style="margin: 5px" id="educationCard">
      <el-form :model="employeeData.educationData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学历：">
              <el-input v-model="employeeData.educationData.education" placeholder="学历" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校：" >
              <el-input v-model="employeeData.educationData.school" placeholder="学校" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学院：" >
              <el-input v-model="employeeData.educationData.college" placeholder="学院" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业：" >
              <el-input v-model="employeeData.educationData.major" placeholder="专业" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入学时间：" >
              <el-date-picker v-model="employeeData.educationData.entry_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业时间：" >
              <el-date-picker v-model="employeeData.educationData.graduation_date" type="date"
                              value-format="YYYY-MM-DD" placeholder="请选择" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <span>毕业证书照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <span>学位证书照片</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="employeeData.educationData.by_certificate" :init-file="employeeData.by_certificate_obj" @fileChange="photoChangeBY" :limit="1"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <kf-image-upload class="avatar-uploader" v-model="employeeData.educationData.xw_certificate" :init-file="employeeData.xw_certificate_obj" @fileChange="photoChangeXW" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">联络信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="紧急联系人姓名：">
              <el-input v-model="employeeData.emergency_name" placeholder="紧急联系人姓名" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关系：">
              <el-select v-model="employeeData.emergency_relation" placeholder="关系" clearable>
                <el-option v-for="item in emergencyRelationList" :key="item.id" :label="item.relationship"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :span="12" label="紧急联系人电话：">
              <el-input v-model="employeeData.emergency_contact" placeholder="紧急联系人电话" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否住宿：">
              <el-switch v-model="employeeData.is_dormitory"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="住址：">
              <el-input v-model="employeeData.address_actual" placeholder="住址" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">备注信息:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否有体检表：">
              <el-switch v-model="employeeData.is_pe"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="奖惩备注：">
              <el-input v-model="employeeData.reward_warning_remark" placeholder="奖惩备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="工伤备注：">
              <el-input v-model="employeeData.work_injury_remark" placeholder="工伤备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="三期女工备注：">
              <el-input v-model="employeeData.female_remark" placeholder="三期女工备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其它备注：">
              <el-input v-model="employeeData.remark" placeholder="其它备注" :rows="2" type="textarea"
                        clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">招聘来源:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推荐人工号：">
              <el-input v-model="employeeData.job_referral_no" placeholder="推荐人" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推荐人姓名：">
              <el-input v-model="employeeData.job_referral_name" placeholder="推荐人" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="招聘来源：">
              <el-input v-model="employeeData.recruit_source" placeholder="招聘来源" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
    <el-card style="margin: 5px;">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件：">
              <FrameItem v-model="employeeData.attach_id" :file-list="employeeData.fileList" :item="uploadObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="employeeData.attach_photo_id_obj" :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </el-scrollbar>
</template>

<script>

import {Plus, Upload} from "@element-plus/icons-vue";
import {Picture as IconPicture} from '@element-plus/icons-vue'
import {ref} from 'vue';
import axios from 'axios'

export default {
  name: "EmployeeShow",
  components: {Upload, Plus, IconPicture, ref},
  inject: ['$fn'],
  setup() {
    const cameraUrl = ref('http://127.0.0.1:38088/video=stream&camidx=1');

    return {
      cameraUrl,
    };
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    },
    formattedSalary() {
      // 格式化显示的金额
      if (this.employeeData.salary) {
        return this.employeeData.salary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return '';
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'id',
        label: 'name',
        checkStrictly: true
      },
      mulOptionProps: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly: true,
        multiple: true
      },
      nameToBoolMap: {
        "公司承担": false,
        "个人承担": true
      },
      costBoolList: [
        { value: true, name: '个人承担' },
        { value: false, name: '公司承担' }
      ],
      employeeData: {
        employee_no:'',
        employee_name:'',
        department_ids:[],
        leader_dept:[],
        position_id:'',
        // position_level:'',
        salary:'',
        gender:'',
        birthday:'',
        age:'',
        id_card_no:'',
        phone:'',
        email:'',
        address:'',
        emergency_contact:'',
        bank_card_no:'',
        is_probation:false,
        is_customization_subsidy:false,
        is_join_attendance:false,
        idCardInfo:{},
        contractData:{},
        salaryData:{},
        educationData: {}
      },
      dialogVisible:false,
      dialogVisibleTwo:false,
      photoType:'',
      is_custom:true,
      idCardInfo:{},
      contractData: {},
      salaryData: {},
      educationData: {},
      eduLevelData: {},
      workExperienceData: {},
      departmentList: [],
      positionList: [],
      // jobLevelList: [],
      employeeTypeList: [],
      laborCompanyList: [],
      companyList:[],
      factoryList:[],
      contractTypeList: [],
      salaryTypeItem: {},
      salaryTypeList: [],
      bankList: [],
      socialSecurityCostList: [],
      socialSecurityBaseTypeList: [],
      socialSecurityAreaList: [],
      emergencyRelationList: [],
      educationLevelList: [],
      socialSecurityTmplData:{},
      housingFundTmplData:{},
      socialSecurityTmplList: [],
      housingFundTmplList: [],
      cardTypeList:[],
      loading: false,
      imageUrl: '',
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      }
    }
  },
  methods: {
    async loadEmployeeInfo() {
      console.log('parentdata:', this.parentData)
      let params = {id: this.parentData.employee_id};
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeInfo', params);
      if (dbEmployee) {
        this.employeeData = dbEmployee;

        const deptIds = this.employeeData.all_department_ids || [];
        let leaderFlags = [];
        if (this.employeeData.is_department_leader && Array.isArray(this.employeeData.is_department_leader)) {
          // 按索引一一对应，长度以 deptIds 为准（更安全）
          leaderFlags = deptIds.map((_, index) => {
            const val = this.employeeData.is_department_leader[index];
            return val === "1" || val === true;
          });
        } else {
          // 没有负责人数据，默认全 false
          leaderFlags = new Array(deptIds.length).fill(false);
        }
        this.employeeData.leader_dept = leaderFlags;

        if (dbEmployee.idCardInfo) {
          this.idCardInfo = dbEmployee.idCardInfo;
          if(this.idCardInfo){
            this.idCardInfo.marital_status = dbEmployee.marital_status;
            this.idCardInfo.political_affiliation = dbEmployee.political_affiliation;
          }
        }
        if (dbEmployee.contractData) {
          this.contractData = dbEmployee.contractData;
        }
        if (this.salaryTypeList && dbEmployee.salary_type_id !== undefined) {
          const foundItem = this.salaryTypeList.find((item) => item.id === dbEmployee.salary_type_id);
          if (foundItem) {
            this.salaryTypeItem = foundItem;
          }
        }
        if (dbEmployee.sb_template_id){
          for (let socialSecurityTmplListElement of this.socialSecurityTmplList) {
            console.log("找到了")
            if (socialSecurityTmplListElement.id === dbEmployee.sb_template_id){
              this.getSbBase(socialSecurityTmplListElement)
              break
            }
          }
        }
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
      console.log(this.departmentList);
    },
    //获取职位
    async getPosition() {
      let params = {modelId: "hr_position"}
      this.positionList = await this.$http('employeeHRService.getAll', params);
    },
/*    //获取职级
    async getJobLevel() {
      let params = {modelId: "hr_rank"}
      this.jobLevelList = await this.$http('employeeHRService.getAll', params);
    },*/
    //获取员工类型
    async getEmployeeType() {
      let params = {modelId: "hr_employee_type"}
      this.employeeTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取劳务公司列表
    async getLaborCompany() {
      let params = {modelId: "hr_labor_company"}
      this.laborCompanyList = await this.$http('employeeHRService.getAll', params);
    },
    //获取合同类型
    async getContractType() {
      let params = {modelId: "hr_contracts_type"}
      this.contractTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取学历列表
    async getEducation() {
      let params = {modelId: "hr_education_level"}
      this.educationLevelList = await this.$http('employeeHRService.getAll', params);
    },
    //获取薪资类型
    async getSalaryType() {
      let params = {modelId: "salary_type"}
      this.salaryTypeList = await this.$http('salaryTypeSetService.getAll', params);
    },
    //获取开户行
    async getSalaryBank() {
      let params = {modelId: "salary_bank"}
      this.bankList = await this.$http('employeeHRService.getAll', params);
    },
    //获取个人部分社保承担放
    async getSocialSecurity() {
      let params = {modelId: "salary_social_security_cost"}
      this.socialSecurityCostList = await this.$http('employeeHRService.getAll', params);
    },
    getNameToBool(name) {
      return this.nameToBoolMap[name] !== undefined ? this.nameToBoolMap[name] : false;
    },
    // 根据布尔值获取对应的 name
    getBoolToName(bool) {
      for (let key in this.nameToBoolMap) {
        if (this.nameToBoolMap[key] === bool) {
          return key;
        }
      }
      return "";
    },
    //获取社保基数类型
    async getSocialSecurityBase() {
      let params = {modelId: "salary_base_type"}
      this.socialSecurityBaseTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保缴纳地
    async getSocialSecurityArea() {
      let params = {modelId: "salary_social_security_area"}
      this.socialSecurityAreaList = await this.$http('employeeHRService.getAll', params);
    },
    //获取紧急联系人关系
    async getEmergencyRelation() {
      let params = {modelId: "hr_emergency_contacts"}
      this.emergencyRelationList = await this.$http('employeeHRService.getAll', params);
    },
    //获取社保模板列表
    async getSocialSecurityTmpl() {
      let params = {modelId: "salary_social_security_template"}
      this.socialSecurityTmplList = await this.$http('salaryInfoSetService.getAllSecurityTmpl', params);
    },
    //获取公积金模板列表
    async getHousingFundTmpl() {
      let params = {modelId: "salary_provident_fund_template"}
      this.housingFundTmplList = await this.$http('salaryInfoSetService.getAllHousingTmpl',params);
    },
    //获取考勤组列表
    async getAttendanceGroup() {
      let params = {modelId: "attendance_group"}
      this.attendanceGroupList = await this.$http('attendanceGroupService.getAll',params);
    },
    //获取证件类型
    async getCardType() {
      let params = {modelId: "hr_document"}
      this.cardTypeList = await this.$http('employeeHRService.getAll', params);
    },
    //获取公司
    async getCompany() {
      let params = {modelId: "hr_document"}
      this.companyList = await this.$http('sysFactoryService.getCompanyByUser', params);
    },
    //获取厂区
    async getFactory() {
      let params = {modelId: "hr_document"}
      this.factoryList = await this.$http('sysFactoryService.getAllFactory', params);
    },
    getEduName(item) {
      console.log(item);
      this.eduLevelData = item;
      this.educationData.education_name = item.education_level_name;
      this.educationData.education = item.id;
    },
    getSbBase(item) {
      console.log("sb",item);
      this.socialSecurityTmplData = item;
      this.employeeData.sb_template_id = item.id;
      this.employeeData.sb_base_area = item.area_name;
    },
    setSbBase() {
      console.log(this.employeeData.is_custom_base);
      if (this.employeeData.is_custom_base) {
        this.is_custom = false;
      } else {
        this.is_custom = true;
      }
    },
    salaryChange(item) {
      console.log(item);
      this.salaryTypeItem = item;
      this.employeeData.salary_type_id = item.id;
      this.employeeData.salary_car = item.salary_car;
      this.employeeData.salary_house = item.salary_house;
      this.employeeData.salary_on_job = item.salary_on_job;
      this.employeeData.salary_full_attendance = item.salary_full_attendance;
      this.employeeData.salary_work_year = item.salary_work_year;
    },
    addEducationHistory() {
      //document.getElementById('educationCard').style.display = 'block';
      if (!this.educationData.education) {
        return this.$message.error("学历不能为空")
      }
      if (!this.educationData.school) {
        return this.$message.error("学校不能为空")
      }
      if (!this.educationData.major) {
        return this.$message.error("专业不能为空")
      }
      if (!this.educationData.entry_date) {
        return this.$message.error("学历开始时间不能为空")
      }
      if (!this.educationData.graduation_date) {
        return this.$message.error("学历结束时间不能为空")
      }
      //this.educationData.entry_date  = this.educationData.entry_date.toLocaleDateString();
      //this.educationData.graduation_date  = this.educationData.graduation_date.toLocaleDateString();
      this.educationData.title = this.educationData.entry_date + " ~ " + this.educationData.graduation_date;
      this.employeeData.educationData.push(this.educationData);
      this.employeeData.educationData.sort((a, b) => {
        return a.entry_date - b.entry_date;
      });
      this.educationData = {};
      this.eduLevelData = {};
    },
    //删除列表中的学历
    delEduHistory(index) {
      console.log(index);
      this.employeeData.educationData.splice(index, 1);
    },
    cancelWork() {
      document.getElementById('educationCard').style.display = 'none';
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    async photoChange(ids){
      console.log(ids)
      if (ids.length <= 0){
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    }
  },
  created() {
    this.getFactory();
    this.getCompany();
    this.getPosition();
    // this.getJobLevel();
    this.getDepartmentList();
    this.getEmployeeType();
    this.getLaborCompany();
    this.getContractType();
    this.getSalaryType();
    this.getSalaryBank();
    this.getSocialSecurity();
    this.getSocialSecurityBase();
    this.getSocialSecurityArea();
    this.getEmergencyRelation();
    this.getEducation();
    this.getHousingFundTmpl();
    this.getSocialSecurityTmpl().then(()=>{
      this.loadEmployeeInfo();
    });
    this.getCardType();

  },

}
</script>

<style lang="less">
.employee-photo {
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 280px;
  }
  .el-upload--picture-card{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 280px;
    height: 320px;
  }
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}
.image-slot .el-icon {
  font-size: 30px;
}

.switch-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 各开关之间的间距 */
  align-items: center;
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.dept-label {
  font-size: 14px;
  color: #606266;
}
</style>